var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './rating.styles';
import { dictionary } from '@mf-cms/helpers';
import { MFElement } from '../mfelement/mfelement';
let PRating = class PRating extends MFElement {
    constructor() {
        super(...arguments);
        this.value = 0;
        this.culture = 'en-GB';
    }
    static { this.styles = styles; }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        return html ` <div class="rating-container" role="presentation"> ${Array.from({ length: 5 }, (_, i) => i + 1).map((i) => html `
            <div class="rating">
              ${i <= this.value
            ? html ` <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16" > <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" /> </svg> `
            : html ` <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star" viewBox="0 0 16 16" > <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" /> </svg> `}
            </div>
          `)}
        <div class="sr-only">${dictionary(this.culture, 'general', 'rating', [this.value])}</div>
      </div>
    `;
    }
};
__decorate([
    property({ type: Number })
], PRating.prototype, "value", void 0);
__decorate([
    property({ type: String })
], PRating.prototype, "culture", void 0);
PRating = __decorate([
    customElement('p-rating')
    /**
     * PRating component
     *
     * @class PRating
     * @typedef {PRating}
     * @extends {LitElement}
     */
], PRating);
export { PRating };
